import {combineReducers} from 'redux';
import addCollaboratorDetailsReducer from './addCollaboratorReducer';
import advanceSearchReducer from './advanceSearchReducer';
import applicationAccessReducer from './applicationAccessReducer';
import contactsGroupItemReducer from './contactsGroupItemReducer';
import contactsHistoryLogsReducer from './contactsHistoryLogsReducer';
import contactReducer from './contactReducer';
import contactDetailsReducer from './contactDetailsReducer';
import customFieldsReducer from './customFieldsReducer';
import sharingDetailsReducer from './sharingDetailsReducer';
import domainGroupReducer from './domainGroupReducer';
import profileReducer from './profileReducer';
import languageReducer from './languageReducer';
import dragNDropReducer from './dragNDropReducer';
import syncStatusReducer from './syncStatusReducer';
import usersListReducer from './usersListReducer';
import msgBarReducer from './msgBarReducer';
import popupReducer from './popupReducer';
import chromeExtensionReducer from './chromeExtensionReducer';
import guidedToursReducer from './guidedToursReducer';
import commentReducer from './commentReducer';
import directoryGroupReducer from './directoryGroupReducer';
import systemGroupReducer from './systemGroupReducer';
import retrialEligibleReducer from './retrialEligibleReducer';
import mobileReducer from './mobileReducer';
import permissionReducer from './permissionReducer';
import suspiciousContactsDeletionReducer from './suspiciousContactsDeletionReducer';

const reducers = combineReducers({
	addCollaboratorDetailsReducer,
	advanceSearchReducer,
	applicationAccessReducer,
	contactsGroupItemReducer,
	contactsHistoryLogsReducer,
	contactReducer,
	contactDetailsReducer,
	customFieldsReducer,
	chromeExtensionReducer,
	sharingDetailsReducer,
	domainGroupReducer,
	profileReducer,
	languageReducer,
	dragNDropReducer,
	syncStatusReducer,
	usersListReducer,
	msgBarReducer,
	popupReducer,
	guidedToursReducer,
	commentReducer,
	directoryGroupReducer,
	systemGroupReducer,
	retrialEligibleReducer,
	mobileReducer,
	permissionReducer,
	suspiciousContactsDeletionReducer
});

export default reducers;
